import(/* webpackMode: "eager" */ "/home/httpd/winteria/mark-ii-actions-runner/mark_ii/winteria-flex/winteria-flex/app/global-error.tsx");
